import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedMovies from './components/FeaturedMovies';
import CategorySection from './components/CategorySection';
import LatestMovies from './components/LatestMovies';
import ClassicMovies from './components/ClassicMovies';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '8090影视',
    url: 'https://8090movie.com',
    description: '8090影视打造电影大全平台，聚合最新电影、经典电影、高清电影资源，涵盖华语电影、欧美电影等海量片库',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://8090movie.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHead
        title="8090影视 - 电影大全 | 最新电影与经典电影高清在线观看"
        description="8090影视打造电影大全平台，聚合最新电影、经典电影、高清电影资源，涵盖华语电影、欧美电影等海量片库，高清画质流畅播放尽在掌握。"
        keywords="8090影视,电影大全,最新电影,经典电影,高清电影,华语电影,欧美电影,电影在线观看"
        canonicalUrl="https://8090movie.com/"
        schema={websiteSchema}
      />
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <FeaturedMovies />
        <CategorySection />
        <LatestMovies />
        <ClassicMovies />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}